import General from './General';
export default General;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/index.ts